import { useLazyQuery } from "@apollo/client";
import { LIST_ALL_REASONS } from "../graphql/checkin.graphql";
import { getOptions } from "./array-utils";
import { useCallback } from "react";
import { useTranslation } from "next-i18next";

const useReasons = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation();

  const [fetchReasons] = useLazyQuery(LIST_ALL_REASONS);

  const useReasons = useCallback(
    async (is_misc) => {
      const response = await fetchReasons({
        fetchPolicy: "network-only",
      });

      const allReasons = getOptions(
        "value",
        response?.data?.checkout_reason,
        false,
        false,
        ["value", "comment"]
      );

      const finalReasons = allReasons
        .map((r) => ({
          label:
            language == "es"
              ? t(`views.checkin.checkout.form.reasons.${r.value}`)
              : r.comment,
          value: r.value,
        }))
        .filter(
          (r) => r.value !== "END_SHIFT" || (r.value === "END_SHIFT" && is_misc)
        );

      return finalReasons;
    },
    [fetchReasons, language, t]
  );

  return useReasons;
};

export { useReasons };
